import * as React from "react";
import { forwardRef } from "react";
const SvgText = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 11 11", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M.8.875v4h2v-2h2v6h-2v2h6v-2h-2v-6h2v2h2v-4z", fill: "#000", fillRule: "evenodd" }));
const ForwardRef = forwardRef(SvgText);
export default ForwardRef;
